module.exports = __webpack_public_path__ + "static/innod-20e34e88de650bd6c7e1c14bb43d3152.png";